import { HttpClient } from '../httpClient';
import TreatmentRulesResponse from '../responses/treatmentRulesResponse';

const httpClient = new HttpClient();

export const getCaseloadTreatmentRulesByCaseloadId = async (caseloadId: number) => {
  return httpClient.get<TreatmentRulesResponse>({
    url: `/v1/treatmentRules/caseloadTreatmentRulesByCaseloadId/${caseloadId}`,
    requiresToken: true,
  });
};

export const getCaseloadTreatmentRulesByDisciplineId = async (disciplineId: number) => {
  return httpClient.get<TreatmentRulesResponse>({
    url: `/v1/treatmentRules/caseloadTreatmentRulesByDisciplineId/${disciplineId}`,
    requiresToken: true,
  });
};